export default __webpack_public_path__ + "static/media/Snd_LowerQTurn.29beb575.mp3";